import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import BrandCarousel from "@/components/BrandCarousel";
import Process from "@/components/Process";
import Gallery from "@/components/Gallery";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Landing() {
  return (
    <div className="min-h-screen bg-forest text-ivory" data-testid="landing-page">
      <Nav />
      <Hero />
      <Gallery />
      <About />
      <Services />
      <Process />
      <BrandCarousel />
      <Contact />
      <Footer />
    </div>
  );
}
